export default "__VITE_ASSET__831f5172__"